<template>
  <div>
    <particles-bg type="cobweb" :bg="true" color="#ffffff" />
    <el-avatar :size="200" :src="portrait" fit="cover" style="margin-top: 10%">
    </el-avatar>
    <h1 style="color: white;font-weight: bold;">JAKE MA</h1>
    <SocialAccounts />
  </div>
</template>
<script>
import { ParticlesBg } from "particles-bg-vue";
import portrait from "./assets/images/pixel_portrait.png";
import SocialAccounts from "./components/SocialAccounts.vue";

export default {
  components: {
    ParticlesBg,
    SocialAccounts,
  },
  data() {
    return {
      portrait: portrait,
    };
  },
};
</script>
<style scoped>
.canvas {
  background: #000000;
}
</style>
